export const DELIVERY_STATUSES = [
    { id: 1, name: 'Доставлен' },
    { id: 2, name: 'Недоставленные' },
    { id: 3, name: 'Доставляется' },
    { id: 5, name: 'Самовывоз' },
]
